export default [
    // 首页
    {
        path: '/policy',
        name: 'policy',
        component: () =>
            import ('@/views/Policy/index.vue'),
    },
    {
        path: '/poldtl',
        name: 'poldtl',
        component: () =>
            import ('@/views/Policy/details.vue'),
    },
]